import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaLiberacoesComponent } from "./aba-liberacoes.component";

@NgModule({
    declarations: [AbaLiberacoesComponent],
    imports:[SharedModule],
    exports:[AbaLiberacoesComponent]
})
export class AbaLiberacoesModule {}